const cdnUrl = process.env.VUE_APP_AZURE_CDN_URL;
const container = process.env.VUE_APP_AZURE_CONTAINER;

export function cdnImgUrl(imagePath) {
  if(imagePath.startsWith('/')) {
    const cleanPath = imagePath.slice(1);
    return `${cdnUrl}/${container}/${cleanPath}`
  }
  return `${cdnUrl}/${container}/${imagePath}`;
}

export function parseImagePath(imageUrl) {
  if (!imageUrl) {
    return ''
  }
  if (!imageUrl.startsWith(cdnUrl)) {
    return ''
  }
  try {
    const url = new URL(imageUrl)
    if (!url){
      return ''
    }
    let pathname = url.pathname
    if (!pathname) {
      return ''
    }
    if (pathname.startsWith("/")) {
      pathname = pathname.slice(1)
    }
    if (!pathname.startsWith((container))) {
      return ''
    }
    return pathname.slice(container.length + 1)
  } catch (e) {
    console.error('Invalid URL:[%s]', imageUrl, e)
    return ''
  }

}